import axios from "axios";
import store from "@/store/root";

import { auth } from "@/auth";
import Cache from "@/tools/msa/utils/cache";
import { makeFormData } from "@/tools/msa/utils/forms";
import { Response } from "@/tools/msa/models/requests/extraction/legacy";

const cache = new Cache("DOCUMENT_CACHE");

export const calculateFileChecksum = async (file: File) =>
  Array.from(
    new Uint8Array(
      await crypto.subtle.digest("SHA-256", await file.arrayBuffer())
    )
  )
    .map(byte => byte.toString(16).padStart(2, "0"))
    .join("");

export const calculateChecksumFromContext = async (context: any) =>
  calculateFileChecksum(context.file);

export const uploadFile = async (context: any, event: any) => {
  if (!context.file) {
    return;
  }

  if (process.env.NODE_ENV !== "production") {
    const checksum = await calculateChecksumFromContext(context);

    const cached = (await cache.all()).find(
      entry => entry.checksum === checksum
    );

    if (cached) {
      return {
        cached: true,
        sessionId: cached.sessionId,
        results: cached.results
      };
    }
  }

  return {
    cached: false,
    ...(await axios
      .post(
        "/jobs",
        makeFormData([["document", context.file], ["tool", "msa"]]),
        {
          baseURL: (store.state as any).settings.current.endpoints.textractor,
          headers: await auth.headers()
        }
      )
      .then(response => ({
        sessionId: response.headers["x-session-id"],
        jobId: response.data.id
      })))
  };
};

export const processResults = async (context: any, event: any) => {
  const results = await axios
    .post<Response>(
      `/results`,
      { id: context.jobId },
      {
        headers: {
          "X-Session-Id": context.sessionId,
          ...(await auth.headers())
        },
        baseURL: (store.state as any).settings.current.endpoints.textractor
      }
    )
    .then(response => response.data);

  if (results.outcome === "success" && process.env.NODE_ENV !== "production") {
    await cache.push({
      checksum: await calculateChecksumFromContext(context),
      sessionId: context.sessionId,
      results
    });
  }

  return results;
};
